import { authPost } from '../http_client.js';
import type { BotGiftClaimDto } from '../dto/bot_gift.dto.js';

export function claimBotGift( id: string ): Promise<BotGiftClaimDto>
{
  return authPost<BotGiftClaimDto>( 'api/player/me/bot-gift/claim', { id } );
}
